export default function ApprovedTag({
  text
}: Readonly<{
  text: string;
}>) {
  return (
    <span
      className='bg-slate-300 px-2 rounded-full text-black text-xs'
    >
      {text}
    </span>
  );
}